import React from 'react';

type Tone = 'running' | 'paused' | 'succeeded' | 'failed' | 'cancelled' | 'neutral';

const TONE: Record<Tone, { bg: string; fg: string }> = {
  running:   { bg: 'var(--mx-info-weak)',    fg: 'var(--mx-info)' },
  paused:    { bg: 'var(--mx-warning-weak)', fg: 'var(--mx-warning)' },
  succeeded: { bg: 'var(--mx-success-weak)', fg: 'var(--mx-success)' },
  failed:    { bg: 'var(--mx-danger-weak)',  fg: 'var(--mx-danger)' },
  cancelled: { bg: 'var(--mx-surface-2)',    fg: 'var(--mx-text-muted)' },
  neutral:   { bg: 'var(--mx-surface-2)',    fg: 'var(--mx-text-muted)' },
};

// Map any run/stage/document status onto a tone.
function toneFor(status: string): Tone {
  const s = (status || '').toLowerCase();
  if (['succeeded', 'exported', 'done'].includes(s)) return 'succeeded';
  if (['failed', 'error', 'rejected'].includes(s)) return 'failed';
  if (['cancelled', 'skipped'].includes(s)) return 'cancelled';
  if (['paused', 'cancelling', 'pending'].some((x) => s.includes(x))) return 'paused';
  if (s.startsWith('awaiting')) return 'paused';
  if (['running', 'classifying', 'extracting', 'evaluating', 'ingested'].some((x) => s.includes(x)))
    return 'running';
  return 'neutral';
}

const LABELS: Record<string, string> = {
  awaiting_schema_approval: 'awaiting schema',
  awaiting_sanity_check: 'awaiting review',
};

const StatusPill: React.FC<{ status: string; pulse?: boolean }> = ({ status, pulse }) => {
  const tone = toneFor(status);
  const c = TONE[tone];
  const label = LABELS[status] || status.replace(/_/g, ' ');
  return (
    <span className="mx-pill" style={{ background: c.bg, color: c.fg }}>
      <span className={`mx-pill-dot ${pulse && tone === 'running' ? 'mx-pulsing' : ''}`} />
      {label}
    </span>
  );
};

export default StatusPill;
